export const Devices = {
  mobile: 'mobile',
  tablet: 'tablet',
  laptop: 'laptop',
  desktop: 'desktop',
  custom1300 : 'custom1300'
};
export type Devices = typeof Devices[keyof typeof Devices];

export const getPadding = (width: number) => {
  const mapped = width < 768 ? Devices.mobile : width < 1024 ? Devices.tablet : width < 1440 ? Devices.laptop : Devices.desktop;
  return paddings[mapped];
};

export const breakpoints = {
  mobile: 520,
  tablet: 868,
  laptop: 1025,
  custom1300 : 1400,
  desktop: 1534,
};

export const paddings = {
  mobile: 20,
  tablet: 40,
  laptop: 45,
  desktop: 50,
};

export const gutters = {
  mobile: 10,
  tablet: 14,
  laptop: 16,
  desktop: 18,
};

export const tokens = {
  desktopMargin: '1.17vw',
  desktopPadding: '3.25vw',
  desktopCols: 12,
  mobileCols: 8,
  mobilePadding: 21,
};
